function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState } from 'react';
import './ActionsMenu.css';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import I18n from '../../../I18n/I18n/I18n';
import AdditionalIntl from '../../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/ActionsMenu.en.json';
import MoveModal from './MoveModal/MoveModal';
import DeleteModal from './DeleteModal/DeleteModal';
import ThemeContext from '../../../ThemeContext';
import { WmActionMenu, WmMenuitem } from '@watermarkinsights/ripple-react';
var MESSAGES = normalizeLocaleData(en, '@dm/components.actionsMenu');
export default function ActionsMenu(_ref) {
  var flags = _ref.flags,
    focusOnRow = _ref.focusOnRow,
    item = _ref.item,
    itemI18n = _ref.itemI18n,
    items = _ref.items;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDeleteModal = _useState2[0],
    setShowDeleteModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMoveModal = _useState4[0],
    setShowMoveModal = _useState4[1];
  var resetState = useCallback(function () {
    setShowDeleteModal(false);
    setShowMoveModal(false);
  }, []);
  var deleteItem = useCallback(function () {
    if (item) {
      item.onDropIndexClick(item.index)(false); // false = no event
      focusOnRow(item.index);
    }
    resetState();
  }, [item, focusOnRow, resetState]);
  var moveItem = useCallback(function (newIndex) {
    if (item) {
      item.onReorderClick(item.index, newIndex)(false); // false = no event
    }
    resetState();
  }, [item, resetState]);
  var onShowMoveModal = useCallback(function () {
    setShowMoveModal(true);
  }, []);
  var onShowDeleteModal = useCallback(function () {
    setShowDeleteModal(true);
  }, []);
  var onAddBefore = useCallback(function () {
    var beforeIndex = item.index;
    item.onAddIndexClick(beforeIndex)(false);
    focusOnRow(beforeIndex);
  }, [item, focusOnRow]);
  var onAddAfter = useCallback(function () {
    var afterIndex = item.index + 1;
    item.onAddIndexClick(afterIndex)(false);
    focusOnRow(afterIndex);
  }, [item, focusOnRow]);
  var menuId = "_dm-form-dsa__".concat(item.key);
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: MESSAGES,
    namespace: "@dm/components.actionsMenu"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: "ripple"
  }, showDeleteModal && /*#__PURE__*/React.createElement(DeleteModal, {
    refocusEl: "#".concat(menuId),
    isShowing: showDeleteModal,
    onCancel: resetState,
    onDelete: deleteItem
  }), showMoveModal && /*#__PURE__*/React.createElement(MoveModal, {
    refocusEl: "#".concat(menuId),
    isShowing: showMoveModal,
    item: item,
    itemI18n: itemI18n,
    items: items,
    onCancel: resetState,
    onMove: moveItem
  })), (flags.canAdd || flags.canMove || flags.canDelete) && /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: "ripple"
  }, /*#__PURE__*/React.createElement(WmActionMenu, {
    id: menuId,
    actionMenuType: "icon",
    tooltip: MESSAGES['@dm/components.actionsMenu.menu-button-label']
  }, flags.canAdd && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WmMenuitem, {
    className: "test",
    onClick: onAddBefore
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.actionsMenu.add-above"
  })), /*#__PURE__*/React.createElement(WmMenuitem, {
    onClick: onAddAfter
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.actionsMenu.add-below"
  }))), flags.canMove && /*#__PURE__*/React.createElement(WmMenuitem, {
    onClick: onShowMoveModal
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.actionsMenu.move"
  })), flags.canDelete && /*#__PURE__*/React.createElement(WmMenuitem, {
    onClick: onShowDeleteModal
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.actionsMenu.delete"
  }))))));
}